import React from "react"
import PageHeaderWrapper from "../../components/PageHeaderWrapper"
import { connect } from "react-redux"
import { TableComp } from 'sz-react-utils'
import { Card, Row, Col, Select, Drawer, Switch } from 'antd'
import Request from "../../request"
import _ from 'lodash'
import async from 'async'
import moment from "moment"
const { Option } = Select
const dateFormat = localStorage.getItem('company-details')?JSON.parse(localStorage.getItem('company-details')).dateFormat:'DD.MM.YYYY'

class DetailDrawer extends React.Component {
    state = {
        visible: true,
        total:0
    }

    onClose = () => {
        this.setState({ visible: false })
        setTimeout(() => {
            this.props.onClose()
        }, 400)
    }

    constructor(props) {
        super(props)
        this.table = React.createRef()
    }

    apiRequest = (params) =>{
        return new Promise(async(resolve)=>{
            let {viewData} = this.props
            params.viewDetails = {...viewData}
            let response = await Request.viewReportDetails(params)
            this.setState({total:response.total})
            return resolve(response)
        })
    }

    


    render() {
        let { viewData } = this.props
        let {total} = this.state
        const studentColumns = [
            {
                title:'Sr. No.',
                key:'serialNumber',
                render:(text,record, index) =>(
                    <div>{index+1}</div>
                )
            },
            {
                title:'V.I.D',
                key:'id'
            },
            {
                title:'Student Name',
                key:'studentName'
            },
            {
                title:'DOB',
                key:'dateOfBirth',
                render:(text,record) =>(
                    <div>{moment(text).format(dateFormat)}</div>
                )
            },
            {
                title:'At Stage',
                key:'atLevel'
            },
            {
                title:'Mobile',
                key:'mobile',
                render:(text,record)=>(
                    <div>{record.countryCode}{record.mobile}</div>
                )
            },
            {
                title:'Mode',
                key:'location'
            }
        ]
        const visitorColumns = [
            {
                title:'Sr No.',
                key:'serialNumber',
                render:(text,record,index)=>(
                    <div>{index+1}</div>
                )
            },
            {
                title:'V.I.D',
                key:'id'
            },
            {
                title:'Applicant Name',
                key:'applicantName'
            },
            {
                title:'DOB',
                key:'dateOfBirth',
                render:(text,record)=>(
                    <div>{moment(record.dateOfBirth).format(dateFormat)}</div>
                )
            },
            {
                title:'Enquiry Status',
                key:'enquiryStatus',
            },
            {
                title:'Visa Status',
                key:'visaStatus'
            },
            {
                title:'Mobile Number',
                key:'mobileNumber'
            },
            {
                title:'Rating',
                key:'rating'
            }
        ]
        return (
            <Drawer
                title={`${viewData.id} Details: ${total}`}
                placement="right"
                closable={true}
                onClose={this.onClose}
                visible={this.state.visible}
                width={1200}
            >
                <Card bordered={true}>
                    <TableComp
                        columns={viewData.id === "Students"?studentColumns:visitorColumns}
                        ref={this.table}
                        useFixedHeader={true}
                        apiRequest={this.apiRequest}
                        // extraProps={{ scroll: { x: 1400 } }}
                        pagination={{
                            showSizeChanger: true,
                            defaultPageSize: 20,
                            pageSizeOptions: ['10', '20', '50', '100', '1000']
                        }}
                    />
                </Card>
            </Drawer>
        )
    }
}






class OverallBusinessReport extends React.Component {
    state = {
        filterYear: moment().format('YYYY'),
        lastFiveYears: [],
        counsellorsArr: [],
        counsellorId: null,
        counsellorName: null,
        branchs: [],
        branchId: null,
        countryId: null,
        countriesData: [],
        universityId: null,
        uniArr: [],
        showDetailDrawer: false,
        viewData: {},
        dataYears:[2024,2023]
    }

    getYears = () => {
        const currentYear = new Date().getFullYear();
        const lastFiveYears = [];

        for (let i = 0; i < 5; i++) {
            lastFiveYears.push(currentYear - i);
        }
        this.setState({ lastFiveYears })
    }

    loadCounsellors = async () => {
        let { data } = await Request.loadAllCounsellors()
        this.setState({ counsellorsArr: data })
    }


    loadCountries = () => {
        Request.getCountriesWithoutAuth({
            results: 200,
            sortField: 'countryName',
            sortOrder: 'ascend'
        })
            .then(resp => {
                let phoneCodes = [];
                resp.data = resp.data.reduce((temp, vv) => {
                    temp.push({ _id: vv._id, display: vv.countryName });
                    return temp
                }, [])
                this.setState({ countriesData: resp.data });
            })
            .catch(err => {
                console.log(err)
            })
    }

    loadBranches = () => {
        let params = {
            sortField: 'branchName',
            sortOrder: 'ascend',
            results: 1000,
            count: 1000,
            status: true
        }
        Request.loadBranch({ ...params })
            .then(resp => {
                resp.data = resp.data.reduce((temp, vv) => {
                    temp.push({ id: vv._id, display: vv.branchName })
                    return temp
                }, [])
                this.setState({ branchs: resp.data });
            })
            .catch(err => {
                console.log(err)
            })
    }

    changeCounsellor = (counsellorName) => {
        if (counsellorName === undefined) {
            this.setState({ counsellorId: null, counsellorName: null }, () => {
                this.table.current.reload()
            })
        } else {
            let { counsellorsArr } = this.state;
            let foundCounsellor = counsellorsArr.find(obj => obj.name === counsellorName)
            if (foundCounsellor) {
                this.setState({ counsellorId: foundCounsellor._id, counsellorName }, () => {
                    this.table.current.reload()
                })
            }
        }

    }

    showDetailDrawer = (data) => {
        let {branchId, countryId, counsellorId, universityId, filterYear} = this.state
        if(branchId && branchId !==null) {
            data.branchId = branchId
        }
        if(countryId && countryId !==null) {
            data.countryId = countryId
        }
        if(counsellorId && counsellorId !==null) {
            data.counsellorId = counsellorId
        }
        if(universityId && universityId!==null) {
            data.universityId = universityId
        }
        if (filterYear && filterYear !== '') {
            data['createdByUser.time'] = {
                from: moment(filterYear, 'YYYY').startOf('year'),
                to: moment(filterYear, 'YYYY').endOf('year')
            }
        }
        this.setState({ showDetailDrawer: true, viewData: data })
    }

    closeDetailDrawer = () => {
        this.setState({ showDetailDrawer: false, viewData: {} }, () => {
            this.table.current.reload()
        })
    }

    loadUniversities = () => {
        let params = {
            results: 10000,
            count: 10000
        }

        Request.getUniversities({ ...params }).then(resp => {
            resp.data = resp.data.reduce((temp, vv) => {
                temp.push({ id: vv._id, display: vv.universityInstitutionName })
                return temp
            }, [])
            this.setState({ uniArr: resp.data })
        })
    }

    componentDidMount() {
        this.loadUniversities()
        this.getYears()
        this.loadCounsellors()
        this.loadBranches()
        this.loadCountries()
    }

    constructor(props) {
        super(props)
        this.table = React.createRef()
    }

    updateDataYears = (checked,yearr) =>{
        let dataYears = this.state.dataYears
        if(checked === true) {
            dataYears.push(yearr)
        }else if (checked === false) {
            dataYears = dataYears.filter(year=>year !== yearr)
        }
        this.setState({dataYears})
    }

    apiRequest = (params) => {
        return new Promise(async (resolve) => {
            let { filterYear, counsellorId, branchId, countryId, universityId, dataYears } = this.state
            // if (filterYear && filterYear !== '') {
            //     params['createdByUser.time'] = {
            //         from: moment(filterYear, 'YYYY').startOf('year'),
            //         to: moment(filterYear, 'YYYY').endOf('year')
            //     }
            // }
            if (counsellorId && counsellorId !== null) {
                params['counsellorId'] = counsellorId
            }
            if (branchId && branchId !== null) {
                params['branchId'] = branchId
            }
            if (countryId && countryId !== null) {
                params['countryId'] = countryId
            }
            if (universityId && universityId !== null) {
                params['universityId'] = universityId
            }
            if(dataYears && dataYears.length>0) {
                params['dataYears'] = dataYears
            }
            let response = await Request.getOverallBusinessReport(params)
            resolve(response)
        })
    }

    render() {
        let { lastFiveYears, counsellorsArr, branchs, countriesData, uniArr, showDetailDrawer, viewData } = this.state

        const columns = [
            {
                title: 'Type',
                key: "createdByUser.time",
                dataIndex: "_id",
                render: (text, record) => (
                    <strong>{text}</strong>
                )
                // filters:lastFiveYears && lastFiveYears.map(x => ({ value: x, text: x })),
            },
            {
                title: 'Total Leads',
                key: 'totalLeads',
                render: (text, record) => (
                    <a onClick={() => this.showDetailDrawer({ id: record._id, field: 'totalLeads' })}>{text}</a>
                )
            },
            {
                title: 'Converted',
                key: 'convertedLeads',
                render:(text,record)=>(
                    <a onClick={() => this.showDetailDrawer({ id: record._id, field: 'convertedLeads' })}>{text}</a>
                )
            },
            {
                title: 'In Pipeline',
                key: 'pipelineLeads',
                render:(text,record)=>(
                    <a onClick={() => this.showDetailDrawer({ id: record._id, field: 'pipelineLeads' })}>{text}</a>
                )
            },
            {
                title: "Visa Waiting",
                key: 'visaWaiting',
                render:(text,record)=>(
                    <a onClick={() => this.showDetailDrawer({ id: record._id, field: 'visaWaiting' })}>{text}</a>
                )
            },
            {
                title: "Visa Approved",
                key: 'visaApproved',
                render:(text,record)=>(
                    <a onClick={() => this.showDetailDrawer({ id: record._id, field: 'visaApproved' })}>{text}</a>
                )
            },
            {
                title: 'Visa Refused',
                key: 'visaRefused',
                render:(text,record)=>(
                    <a onClick={() => this.showDetailDrawer({ id: record._id, field: 'visaRefused' })}>{text}</a>
                )
            },
            {
                title: 'Enrolled In University',
                key: 'enrolledInUniversity'
            }
        ]

       
        return (

            <PageHeaderWrapper title="Overall Report">
                {
                    showDetailDrawer ?
                        <DetailDrawer viewData={viewData} onClose={this.closeDetailDrawer} />
                        : null
                }
                <Card bordered={false} style={{marginBottom:10}}>
                    <Row>
                        {lastFiveYears && lastFiveYears.map((year,index)=>(
                            <Col span={3}>
                                <Switch value={year} defaultChecked={this.state.dataYears.includes(year)} key={year} onChange={checked=>{
                                    this.updateDataYears(checked, year)
                                }} /><strong style={{marginLeft:5}}>{year}</strong>
                                
                            </Col>
                        ))}
                    </Row>
                </Card>
                {/* <Card bordered={false} style={{ marginBottom: 10 }}>
                    <Row>
                        <Col span={6}>
                            <h4>Show By Year</h4>
                            <Select
                                allowClear
                                showSearch={true}
                                value={this.state.filterYear}
                                placeholder="Select Year"
                                style={{ width: '90%' }}
                                onChange={filterYear => {
                                    this.setState({ filterYear }, () => {
                                        this.table.current.reload()
                                    })
                                }}
                            >
                                {lastFiveYears && lastFiveYears.map((year, index) => {
                                    return (
                                        <Option key={index} value={year}>
                                            {year}
                                        </Option>
                                    )
                                })}
                            </Select>
                        </Col>
                    </Row>
                </Card> */}
                <Card bordered={false} style={{ marginBottom: 10 }}>
                    <Row>
                        <Col span={5}>
                            <h4>Show By Counsellor</h4>
                            <Select
                                allowClear
                                showSearch={true}
                                value={this.state.counsellorName}
                                placeholder="Select Year"
                                style={{ width: '90%' }}
                                onChange={counsellorId => this.changeCounsellor(counsellorId)}
                            >
                                {counsellorsArr && counsellorsArr.map((counsellor, index) => {
                                    return (
                                        <Option key={counsellor._id} value={counsellor.name}>
                                            {counsellor.name}
                                        </Option>
                                    )
                                })}
                            </Select>
                        </Col>
                        <Col span={5}>
                            <div>
                                <h4>Show By Branch</h4>
                                <Select
                                    allowClear
                                    style={{ width: '250px' }}
                                    showSearch={true}
                                    value={this.state.branchId}
                                    placeholder="Select Option"
                                    optionFilterProp="display"
                                    filterOption={(input, option) => {
                                        return (
                                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        )
                                    }}
                                    onChange={branchId => {
                                        this.setState(
                                            {
                                                branchId: branchId && branchId.toString()
                                            },
                                            () => {
                                                setTimeout(() => {
                                                    this.table.current.reload();
                                                }, 500);
                                            }
                                        )
                                    }}>
                                    {branchs.map((val, idn) => {
                                        return (
                                            <Option key={idn} value={val.id}>
                                                {val.display}
                                            </Option>
                                        )
                                    })}
                                </Select>
                            </div>
                        </Col>
                        <Col span={5}>
                            <div>
                                <h4>Show By Country</h4>
                                <Select
                                    allowClear
                                    style={{ width: '250px' }}
                                    showSearch={true}
                                    value={this.state.countryId}
                                    placeholder="Select Option"
                                    optionFilterProp="display"
                                    filterOption={(input, option) => {
                                        return (
                                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        )
                                    }}
                                    onChange={countryId => {
                                        this.setState(
                                            {
                                                countryId: countryId && countryId.toString(),
                                                universityId: null
                                            },
                                            () => {
                                                setTimeout(() => {
                                                    this.table.current.reload();
                                                }, 500);
                                            }
                                        )
                                    }}>
                                    {countriesData.map((val, idn) => {
                                        return (
                                            <Option key={idn} value={val._id}>
                                                {val.display}
                                            </Option>
                                        )
                                    })}
                                </Select>
                            </div>
                        </Col>
                        <Col span={5}>
                            <h4>Show By University</h4>
                            <Select
                                allowClear
                                showSearch={true}
                                style={{ width: '16rem' }}
                                value={this.state.universityId}
                                placeholder="Select University"
                                optionFilterProp="universityInstitutionName"
                                onChange={universityId => {
                                    this.setState(
                                        {
                                            universityId: universityId && universityId.toString(),
                                            countryId: null
                                        },
                                        () => {
                                            setTimeout(() => {
                                                this.table.current.reload();
                                            }, 500);
                                        }
                                    )
                                }}
                                filterOption={(input, option) => {
                                    return (
                                        option.props.children
                                            .toLowerCase()
                                            .indexOf(input.toLowerCase()) >= 0
                                    );
                                }}
                            >
                                {uniArr.map((val, idn) => {
                                    return (
                                        <Option key={idn} value={val.id}>
                                            {val.display}
                                        </Option>
                                    );
                                })}
                            </Select>
                        </Col>
                    </Row>
                </Card>
                <Card>

                    <Card bordered={true}>
                        <TableComp
                            id={"overallReport"}
                            columns={columns}
                            ref={this.table}
                            useFixedHeader={true}
                            apiRequest={this.apiRequest}
                            // extraProps={{ scroll: { x: 1400 } }}
                            pagination={{
                                showSizeChanger: false,
                                defaultPageSize: 20,
                                pageSizeOptions: ['10', '20', '50', '100', '1000']
                            }}
                        />
                    </Card>
                </Card>

            </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({ global }) => ({
    categories: global.categories,
    loading: global.buttonLoading
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(OverallBusinessReport)